export default {
  liveRooms: []
}